
export default function closeAndOpen(ref, st){
  ref.current.classList.toggle(st)
}